import { ChangeEvent, FC, useCallback, useContext, useEffect, useState } from "react";
import { UsersTable } from "./components/UserTable/UsersTable";
import { Row, Col, Input, Divider, message } from "antd";
import { useQuery } from "@tanstack/react-query";
import { userManagementService } from "../../services/user-management";
import { Role, UserManagement as UserManagementInterface } from "../../types/user-management";
import { DataContext } from "../../contexts/DataContext";

const { Search } = Input;

interface Props {}

export const UserManagement: FC<Props> = () => {
  const [searchValue, setSearchValue] = useState("");
  const [usesManagement, setUsersManagement] = useState<UserManagementInterface[]>([]);

  const {
    drawRequestContext: { refetchDrawRequestData }
  } = useContext(DataContext);

  const {
    data: userManagement,
    isFetching: isUserManagement,
    isLoading: isUserManagementLoading
    // refetch: refetchUserManagement,
  } = useQuery(["user-management"], () => userManagementService.getAllUserManagement(), { initialData: [] });

  const onUserEdited = async (id: number, roles: Role[]) => {
    try {
      await userManagementService.editUserRoles(id, roles);
      setUsersManagement((old) => [
        ...old.map((item) => {
          if (item.id === id)
            return {
              ...item,
              roles
            };
          return item;
        })
      ]);
      refetchDrawRequestData()
      message.success({ content: "Success", key: "editingUSer" });
    } catch (error) {
      console.error(error);
      message.error({ content: "Ups, something went wrong, please try again later", key: "editingUSer" });
    }
  };

  useEffect(() => {
    setUsersManagement([...userManagement]);
  }, [userManagement]);

  const data = useCallback(() => {
    return usesManagement.filter((dat) => JSON.stringify(dat).toLowerCase().includes(searchValue.toLowerCase())) || [];
  }, [usesManagement, searchValue]);

  return (
    <>
      <Row style={{ marginBottom: "30px" }}>
        <Col span={14}>
          <Row>
            <Col span={14}>
              <label>Search:</label>
            </Col>
          </Row>
          <Row>
            <Col span={14}>
              <Search
                style={{ width: "60%" }}
                size="large"
                value={searchValue}
                onChange={(e: ChangeEvent<HTMLInputElement>) => setSearchValue(e.target.value)}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col>
          <Divider orientation="center">List of users</Divider>
          <UsersTable
            onUserEdited={onUserEdited}
            data={data()}
            key={"id"}
            isLoading={isUserManagement || isUserManagementLoading}
          ></UsersTable>
        </Col>
      </Row>
    </>
  );
};
